/**
 * The `renglo` source: the console's real data. It wraps `src/api-utils` as it is, so the
 * transport, the auth headers and the portfolio and organization lookup do not change.
 */
import { getBlastRadiusScoresAll } from '../../api-utils/blast';
import {
  getBusinessElementsAll,
  getInfrastructureElementsAll,
  getThreatElementsAll,
} from '../../api-utils/elements';
import { getEntityRiskScoresAll } from '../../api-utils/entity_risk';
import { getRemediations } from '../../api-utils/remediations';
import { getSecurityEventsAll } from '../../api-utils/security_events';
import { getSources } from '../../api-utils/sources';
import { getThreatCandidatesAll, getThreatEventsAll } from '../../api-utils/threats';
import { getFunnelCounters } from '../../api-utils/counters';
import type { C3DataSource } from '../ports';

export function createRengloSource(): C3DataSource {
  return {
    kind: 'renglo',
    listThreatEvents: getThreatEventsAll,
    listThreatCandidates: getThreatCandidatesAll,
    listThreatElements: getThreatElementsAll,
    listInfrastructureElements: getInfrastructureElementsAll,
    listBusinessElements: getBusinessElementsAll,
    listSecurityEvents: getSecurityEventsAll,
    listRemediations: getRemediations,
    listBlastRadiusScores: getBlastRadiusScoresAll,
    listEntityRiskScores: getEntityRiskScoresAll,
    listSources: getSources,
    getFunnelCounters,
  };
}
